export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-lightning-actions-55f1032708e3ebfd2cc2ae712451be4e.gif";